export default [
    { name: 'currency', path: '/currency' },
    { name: 'about', path: '/about' },
]